import { Injectable } from '@angular/core';
import { HelperService } from '../helper/helper.service';
import { TxService } from '../shared/tx.service';
import { SmartHttpService } from '../smart-http/smart-http.service';
import { isPlatform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { HttpEvent } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { AccountService } from '../user/account.service';

@Injectable({
  providedIn: 'root',
})
export class CalendarEventsService {
  apiParams: { platform: string; deviceid: string };
  constructor(
    private httpClient: SmartHttpService,
    private helperService: HelperService,
    private envService: TxService,
    private accountService: AccountService
  ) {
    this.initApiParams();
  }
  public get syncCalenderEventsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.syncCalenderEventsApi = `${this.envService.getSyncCalenderEventsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public set syncCalenderEventsApi(value: string) {}

  initApiParams() {
    this.apiParams = {
      platform: isPlatform('ios') ? 'ios' : 'android',
      deviceid: this.accountService.deviceID,
    };
  }
  public syncCalenderEvents(data: any): Observable<any> {
    this.initApiParams();
    return this.httpClient.post(this.syncCalenderEventsApi, {
      events: data,
    });
  }
}
